import { useContext } from "react";
import { CommonMapContext } from "../contexts/CommonMapContext";

const useCommonMap = () => {
  const ctx = useContext(CommonMapContext);
  if (ctx === undefined || ctx === null) {
    throw new Error("useCommonMap must be used within a CommonMapProvider");
  }
  return ctx;
};

export default useCommonMap;
